import React from 'react';
import { Helmet } from 'react-helmet';

var UnexpectedErrorScreen = function UnexpectedErrorScreen() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Unexpected Error")), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mt-4"
  }, "Unexpected Error"), /*#__PURE__*/React.createElement("p", null, "Reload this page and try again later. Contact support if you continue to experience this error.")));
};

export { UnexpectedErrorScreen };